import React from 'react'
import { NavLink } from 'react-router-dom';
import { Title, Subtitle, Subsubtitle, Body, Description } from '../components/Common';

export const ProjectsPage = () => {
  return (
      <div className='w-full min-h-screen flex justify-center bg-stone-200 dark:bg-stone-700'>
          <div className='w-full sm:w-2/3 pt-12 px-8 sm:pt-16 sm:px-10 bg-stone-100 dark:bg-stone-600 dark:text-white'>
              
              <div className='my-8 text-center'>
                <div className='text-sm sm:text-2xl text-center mb-4'>⚠️ This Page is still under development ⚠️</div>
                
                <Subtitle>LIST OF PROJECTS:</Subtitle>

                <Subsubtitle><NavLink to="https://github.com/notalepower/PatchCoreViT">PatchCore Transformed</NavLink></Subsubtitle>
                <Description>This project was part of my master's thesis. It focused on integrating ViTs into PatchCore as an alternative to traditional CNNs.</Description>
                
                <Subsubtitle><NavLink to="/website">notalepower's Website</NavLink></Subsubtitle>
                <Description>The webpage that you're currently on is also a personal project of mine, created to help me learn how to build a website from scratch.</Description>

                <Subsubtitle><NavLink to="https://github.com/notalepower/">A Computer Vision Project</NavLink></Subsubtitle>
                <Description>Coming soon, work in progress.</Description>
                
                <br/><div className='px-12'><hr className='border-stone-700 dark:border-stone-100'/></div>

                <Subtitle>PERSONAL RESOURCES:</Subtitle>

                <Subsubtitle><NavLink to="/todo">My TODO List</NavLink></Subsubtitle>
                <Description> A simple space to keep my tasks in one place and help me stay on track, no matter how much time has passed.</Description>

                <Subsubtitle><NavLink to="/notes">Study Notes Archive</NavLink></Subsubtitle>
                <Description>A personal collection of notes and key takeaways from what I’ve studied, helping me retain and revisit knowledge over time.</Description>

              </div>

          </div>
      </div>
  )
}
